import { InvalidDTOError } from '@/api/errors/InvalidDTOError'
import { TimeStepValueDTO } from './TimeStepValueDTO'
import { TimeStepValueRaw } from './TimeStepValueRaw'

export class TimeStepValueDTOFactory {
  static fromRaw(raw: TimeStepValueRaw): TimeStepValueDTO {
    const timestamp = raw.timestamp

    const maxFloodLevel = raw.max_flood_level
    const maxIntensity = raw.max_intensity
    const maxRisk = raw.max_risk
    const maxRt = raw.max_rt
    const maxTa = raw.max_ta

    const mandatoryFields = [timestamp, maxFloodLevel, maxIntensity, maxRisk, maxRt, maxTa]

    if (mandatoryFields.indexOf(null) !== -1) {
      throw new InvalidDTOError(TimeStepValueDTOFactory.name, raw)
    }

    return new TimeStepValueDTO(
      timestamp as string,
      maxFloodLevel as number,
      maxIntensity as number,
      maxRisk as number,
      maxRt as number,
      maxTa as number,
    )
  }
}
